module.exports = __webpack_public_path__ + "static/media/icon-supplies-floss.dc4cded7.svg";